function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Vue from 'vue';
import { VSelect } from 'vuetify/lib';
import FormMixin from '../form.mixin';

var Select = /*#__PURE__*/function () {
  function Select() {
    _classCallCheck(this, Select);
  }

  _createClass(Select, null, [{
    key: "register",
    value: function register() {
      Vue.component('roche-select', {
        template: "<v-select\n          v-bind=\"bind\"\n          ref=\"select\"\n          item-text=\"label\"\n          item-value=\"value\"\n          v-on=\"$listeners\"\n          :items=\"items\"\n          :menu-props=\"{ offsetY: true, offsetOverflow: true }\"\n          :rules=\"rules\"\n          @input=\"onChange\"\n          @change=\"onChange\"\n          :placeholder=\"value ? undefined : $attrs.placeholder\"\n          persistent-placeholder\n          >\n          <slot/>\n        </v-select>",
        mixins: [FormMixin],
        components: {
          VSelect: VSelect
        },
        props: {
          useObjectValues: {
            type: Boolean,
            "default": false
          }
        },
        computed: {
          el: function el() {
            return this.$refs.select;
          },
          items: function items() {
            if (this.$attrs.items) return this.$attrs.items;

            if (this.$slots["default"]) {
              return this.$slots["default"].filter(function (n) {
                return n.tag === 'option';
              }).map(function (_ref) {
                var _ref$data = _ref.data,
                    data = _ref$data === void 0 ? {} : _ref$data,
                    children = _ref.children;
                return {
                  label: children[0].text,
                  value: data.attrs && data.attrs.value ? data.attrs.value : children[0].text
                };
              });
            }

            return [];
          }
        },
        methods: {
          onChange: function onChange(e) {
            var _this = this;

            if (!this.useObjectValues || !this.bind.multiple) {
              this.$emit('input', e);
              return;
            }

            var objectItems = [];
            e.forEach(function (item) {
              var foundItem = _this.items.find(function (i) {
                return i.value === item;
              });

              if (foundItem) objectItems.push(foundItem);
            });
            this.$emit('input', objectItems);
          }
        }
      });
    }
  }]);

  return Select;
}();

export default Select;